import SvgIcon, { SvgIconProps } from '@material-ui/core/SvgIcon'
import { mdiGauge } from '@mdi/js'
import { FunctionComponent } from 'react'

export const IconGauge: FunctionComponent<SvgIconProps> = (props: SvgIconProps) => (
	<SvgIcon {...props}>
		<path d={mdiGauge} />
	</SvgIcon>
)
